import styled from "styled-components";

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 40px;
  padding: 0 14px;
  border: 1px solid ${(props) => props.theme.borderStrong};
  border-radius: 8px;
  background-color: ${(props) => props.theme.surfaceRaised};
  color: ${(props) => props.theme.textColor};
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  /* surfaceHover is translucent, so layer it over the raised surface */
  &:hover {
    background-image: linear-gradient(
      ${(props) => props.theme.surfaceHover},
      ${(props) => props.theme.surfaceHover}
    );
    border-color: ${(props) => props.theme.mutedTextColor};
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }
`;

const IconImage = styled.img`
  width: 18px;
  height: 18px;
`;

const GoogleButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <Button type="button" onClick={() => onClick()}>
      <IconImage src={`${process.env.PUBLIC_URL}/googleicon.png`} alt="" />
      Continue with Google
    </Button>
  );
};
export default GoogleButton;
